<div class="drawer__content">
  <ng-content></ng-content>
</div>
